import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: rgb(88, 199, 192);
  padding: 2rem 14rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 2rem 1rem;
  }
`;

const FooterSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.align === "left" ? "flex-start" : "center")};
  margin: ${(props) => (props.align === "left" ? "0 5rem 0 0" : "0")};

  @media (max-width: 768px) {
    align-items: center;
    margin: 1rem 0;
  }
`;

const FooterTitle = styled.h3`
  font-size: 25px;
  font-weight: bold;
  margin-bottom: .3rem;
`;

const FooterLink = styled.a`
  color:rgb(10, 10, 10);
  margin-bottom: 0.5rem;
  text-decoration: none;
  font-size: 18px;

  &:hover {
    color: #343a40;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  margin-top: .5rem;

  a {
    color:rgb(37, 37, 37);
    margin-right: .8rem;
    font-size: 24px;
    text-decoration: none;

    &:hover {
      color: #343a40;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      {/* Left-aligned section */}
      <FooterSection align="left">
        <FooterTitle>Sproutron Labs</FooterTitle>
        <p>Copyright 2024 Sproutron Labs. All Rights Reserved.</p>
      </FooterSection>

      {/* Right-aligned sections */}
      <FooterSection>
        <FooterTitle>Company</FooterTitle>
        <FooterLink href="#">Home</FooterLink>
        <FooterLink href="#keyvalue">Features</FooterLink>
      </FooterSection>
      <FooterSection>
        <FooterTitle>Legal</FooterTitle>
        <FooterLink href="#">Privacy Policy</FooterLink>
        <FooterLink href="#">Terms of Use</FooterLink>
        <SocialIcons>
          <a href="#"><i className="fab fa-facebook"></i></a>
          <a href="#"><i className="fab fa-twitter"></i></a>
          <a href="https://www.linkedin.com/company/sproutron-labs/" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin"></i>
          </a>
        </SocialIcons>
      </FooterSection>
    </FooterContainer>
  );
};

export default Footer;
